import { useLayoutEffect, useRef, useState } from 'react'

export function useContainerWidth() {
  const containerRef = useRef(null)
  const chartRef = useRef(null)
  const [width, setWidth] = useState(0)

  useLayoutEffect(() => {
    const update = () => {
      if (chartRef.current !== null) {
        setWidth(containerRef.current?.clientWidth ?? 0)
      }
    }

    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return { containerRef, chartRef, width }
}
